import { useState } from "react";
import { FaTimes } from 'react-icons/fa'
import Modal from 'react-bootstrap/Modal';
import "bulma/css/bulma.css";
import "../Styled.css"
import LoaderHome from "../../Loader/LoaderHome"
import { ReactComponent as PrayingIcon } from "../../../assets/reminder_card/praying.svg";
import { ReactComponent as HealtyIcon } from "../../../assets/reminder_card/healty.svg";
import { ReactComponent as MedicalIcon } from "../../../assets/reminder_card/medical.svg";
import { ReactComponent as WashHandsIcon } from "../../../assets/reminder_card/wash.svg";
import { ReactComponent as ToolsIcon } from "../../../assets/reminder_card/tools.svg";
import { ReactComponent as DocumentsIcon } from "../../../assets/reminder_card/document.svg";
import { ReactComponent as ConfirmIcon } from "../../../assets/reminder_card/confirmation.svg";
import { Card } from "react-bootstrap";

export default function ModalRoleAdd(props) {
  const [propsData, setProopsData] = useState()
  const [loading, setLoading] = useState(false);


  const iconWrapperStyle = {
    height: "180px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }

  const iconStyle = {
    height: "100%",
    width: "auto",
    maxWidth: "100%",
    color: "#29B8FF"
  }


  const reminders = [
    "Mengucapkan terima kasih pada pasien",
    "Membuang limbah medis pada tempatnya",
    "Membereskan dan merapihkan alat serta mensterilkan ruangan",
    "Me-review secara singkat terapi yang dilakukan sebelumnya sudah tepat",
    "Berikan informasi dan edukasi untuk perawatan lanjutan di rumah/kontrol",
  ]



  return (
    <Modal {...props} onHide={props.onHide} size="md" aria-labelledby="contained-modal-title-vcenter" centered style={{ fontFamily: "sans-serif", border: "none" }}>
      {loading && <LoaderHome />}

      <div
        style={{
          width: "100%",
          display: "flex",
          padding: "10px 0px",
          backgroundColor: "#29B8FF",
          position: "sticky",
          top: 0,
          zIndex: 1050
        }}
      >
        <div
          style={{
            flex: "92%",
            fontSize: "20px",
            display: "flex",
            alignItems: "center",
            paddingLeft: "10px",
            color: "white",
            fontWeight: "600"
          }}
        >
          Kartu Pengingat Keselamatan Sesudah Melayani Pasien
        </div>

        <div
          style={{
            flex: "8%",
            fontSize: "30px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "white"
          }}
        >
          <FaTimes
            onClick={() => setProopsData(props.onHide)}
            style={{ cursor: "pointer" }}
          />
        </div>
      </div>

      <Modal.Body
        style={{
          borderBottomLeftRadius: "5px",
          borderBottomRightRadius: "5px",
          border: "none"
        }}
      >
        {reminders.map((text, index) => {
          const isActive = index <= props.activeStep

          return (
            <div className="row align-items-center" key={index}>

              {/* Nomor */}
              <div className="col-md-2">
                <Card
                  className="mb-3 border-0 text-center"
                  style={{
                    backgroundColor: isActive ? "#29B8FF" : "#f5f5f5",
                    color: isActive ? "white" : "#999",
                    transition: "0.3s"
                  }}
                >
                  <Card.Body style={{ fontWeight: "700" }}>
                    {index + 1}
                  </Card.Body>
                </Card>
              </div>

              {/* Deskripsi */}
              <div className="col-md-10">
                <Card
                  className="mb-3 border-0"
                  style={{
                    backgroundColor: isActive ? "#E9F6FF" : "#fff",
                    borderLeft: isActive ? "4px solid #29B8FF" : "4px solid transparent",
                    transition: "0.3s"
                  }}
                >
                  <Card.Body style={{ fontWeight: isActive ? "700" : "600" }}>
                    {text}
                  </Card.Body>
                </Card>
              </div>

            </div>
          )
        })}

      </Modal.Body>
    </Modal>
  );
}
